import { Component, Input } from '@angular/core';

/**
 * Big centered "hero" avatar used at the top of /account and /user-profile.
 * Not the same component as UserAvatarComponent (the small, color-cycling,
 * clickable chip used in the sidemenu) — different size, palette and behavior.
 */
@Component({
  selector: 'app-profile-avatar',
  templateUrl: './profile-avatar.component.html',
  styleUrls: ['./profile-avatar.component.scss'],
  standalone: false
})
export class ProfileAvatarComponent {
  @Input() fullname: string | null | undefined = '';
  /** Not wired up by any caller yet — reserved for the upcoming profile photo feature. */
  @Input() imageUrl: string | null | undefined = null;

  get initials(): string {
    const names = (this.fullname ?? '').trim().split(' ');
    const first = names[0]?.[0] || '';
    const last = names[1]?.[0] || '';

    return `${first}${last}`.toUpperCase();
  }
}
